import client from "services/ngage/api-client";
import {FeatureCollection, Point} from "geojson";
import {DateTime} from "luxon";
import {AxiosRequestConfig} from "axios";

// Types ----

type ActivityFilters = {
  since?: DateTime
  until?: DateTime
  siteId?: number | null
}

type VisitorLocationFilters = {
  since?: DateTime
  until?: DateTime
  limit?: number | null
  siteId?: number | null
}

type VisitorMovementFilters = {
  since?: DateTime
  until?: DateTime
  limit?: number | null
  siteId?: number | null
}

// Queries ----

async function activity(filters?: ActivityFilters, requestConfig?: AxiosRequestConfig) {
  const params = {
    since: filters?.since?.toUTC().toISO(),
    until: filters?.until?.toUTC().toISO(),
    site_id: filters?.siteId,
  };

  const response = await client.get<FeatureCollection<Point>>('/maps/activity', {...requestConfig, params})

  return response.data;
}

async function interactive() {
  const response = await client.get<FeatureCollection>('/maps/interactive');

  return response.data;
}

async function visitorLocation(filters?: VisitorLocationFilters, requestConfig?: AxiosRequestConfig) {
  const params = {
    since: filters?.since?.toUTC().toISO(),
    until: filters?.until?.toUTC().toISO(),
    limit: filters?.limit ?? 5000,
    site_id: filters?.siteId,
  };

  const response = await client.get<FeatureCollection<Point>>('/maps/visitor-location', {...requestConfig, params})

  return response.data;
}

export type VisitorMovementFeatureProperties = {
  occurred_at: number;
  user_uuid: string;
}

async function visitorMovement(filters?: VisitorMovementFilters, requestConfig?: AxiosRequestConfig) {
  const params = {
    since: filters?.since?.toUTC().toISO(),
    until: filters?.until?.toUTC().toISO(),
    limit: filters?.limit ?? 5000,
    site_id: filters?.siteId,
  };

  const response = await client.get<FeatureCollection<Point, VisitorMovementFeatureProperties>>('/maps/visitor-movement', {...requestConfig, params})

  return response.data;
}

const insights = {
  activity,
  interactive,
  visitorLocation,
  visitorMovement,
}

export default insights